import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { IPolicies } from '../shared/models/policies.interface';
import { DWDetails } from '../shared/models/digital-wallet.interface';
import { BillingService } from '../services/billing.service';
import { PolicyService } from '../services/policy.service';
import { tap } from 'rxjs/operators';

export const digitalWalletResolver: ResolveFn<DWDetails> = (route, state) => {
  let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
  let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
  let user = JSON.parse(sessionStorage.getItem('userDetails'));

  const billingService = inject(BillingService);

  if (dwDetails) {
    return dwDetails;
  }

  if (user && user?.userRoleID && user?.userRoleID == '3') {
    return null;
  }

  // Skip DWgetSummary call for pirate ship flow
  const flowType = sessionStorage.getItem('flowType');
  if (state.url.includes('pirate-ship') || flowType === 'pirateship') {
    return null;
  }

  if (policyDetails?.policyCountry_Ext == 'US') {
    let request = {
      productSourceSystem: "gw",
      sourceSystemIdentifierName: "PolicyNumber",
      sourceSystemIdentifier: policyDetails?.policyNumber,
      country: "US",
      roleType: "string",
      productType: "string"
    }
    return billingService.DWgetSummary(request).pipe(  //pipe in order to be able to tap
      tap(  //tap to read response before forwarding it to the subscriber
        data => {
          if (data && data?.message == "Success") {
            sessionStorage.setItem('dwDetails', JSON.stringify(data?.data?.wallet));
          }
        }
      )
    );
  }
};

export const payorResolver: ResolveFn<any> = (route, state) => {
  const policyService = inject(PolicyService);
  let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
  let payorId;
  if (sessionStorage.getItem('payorId') && sessionStorage.getItem('shipperAccountDetails')) {
    payorId = JSON.parse(sessionStorage.getItem('payorId'));
  }

  if (payorId) {
    return payorId;
  }

  let request = {
    childPolicyNumber: policyDetails?.policyNumber
  }

  return policyService.getListOfShipperNumbers(request).pipe(
    tap(
      data => {
        if (data && data.message == "SUCCEEDED") {
          if(data) {
            sessionStorage.setItem('shipperAccountDetails', JSON.stringify(data?.data));
          }
          if (data && data.data?.groupIds?.length == 1) {
            sessionStorage.setItem('payorId', data?.data.groupIds[0]?.groupID);
          }
        }
      }, error => {
        console.log("Error retrieving payor ID");
      }
    )
  );
}
